<template>
  <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="25" cy="25" r="25" fill="#F8F6FF" />
    <!-- 돋보기 렌즈 -->
    <circle cx="22.5" cy="22.5" r="7.5" stroke="#5E47A5" stroke-width="2.5" fill="none" />
    <!-- 돋보기 손잡이 -->
    <path
      d="M28.5 28.5L35 35"
      stroke="#5E47A5"
      stroke-width="2.5"
      stroke-linecap="round"
    />
  </svg>
</template>
